import {
    CLAPI
} from '../clchart/cl.api.js'
import * as Init from '../init.js';
import * as DATAS from '../datas/transdata.js'

export const FWIDTH = 130

export const CHART_VERIFY_MCLASS = {
    style: 'horizontal', // 'vertical'
    title: {
        width: FWIDTH,
        label: '因子分类',
    },
    maxchs: 4,
    ctrls: []
}
// export const MINUTES = ['0945', '1045', '1330', '1445']

export const CHART_VERIFY_MINUTE = {
    style: 'horizontal', // 'vertical'
    title: {
        label: '分时',
    },
    maxchs: 4,
    ctrls: []
}

// export const CHART_VERIFY_FGROUP = {
//     style: 'horizontal', // 'vertical'
//     title: {
//         label: '分组',
//     },
//     maxchs: 6,
//     ctrls: []
// }

// export function clearFgroups() {
//     CHART_VERIFY_FGROUP.ctrls = []
// }
// export function incrFgroups(fname) {
//     // console.log(fname);
//     CHART_VERIFY_FGROUP.ctrls.push({
//         label: fname,
//         clickValue: fname,
//     })
// }

export function getChartLines(grps) {
    let lines = []
    // const shows = (grps + 1) / 4
    for (let wvi = 0; wvi < grps; wvi++) {
        const fname = 'value' + wvi.toString()
        lines.push({
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: [fname], // 参与计算最大值的标签
                minvalue: [fname] // 参与计算最小值的标签
            },
            info: {
                label: (wvi + 1).toString() + ":",
                // colorIndex : 10 + wvi,
                showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
                fieldX: 'date',
                fieldY: fname, // 需要显示的变量，从key中获取对应的数据标签
                format: 'float',
            }
        })
    }
    return lines
}

export function getChartVBars(grps) {
    let lines = []
    grps = 1
    for (let wvi = 0; wvi < grps; wvi++) {
        lines.push({
            className: CLAPI.ClDrawVBar,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: [0.7, 'value'], // 参与计算最大值的标签
                minvalue: [0.0, 'value'] // 参与计算最小值的标签
            },
            info: {
                filled: true,
                // label: (wvi + 1).toString() + ":",
                label : "var:",
                showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
                fieldX: 'index',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'float',
            }
        })
    }
    return lines
}

const MAXGROUPS = 20

let wverify_fields_r = 'date'

for (let wvi = 0; wvi < MAXGROUPS; wvi++) {
    wverify_fields_r += ',' + 'value' + wvi.toString()
}
const FIELD_WVERIFY_R = DATAS.fieldsToFieldsIndex(wverify_fields_r)

const mverify_fields_p = 'index,value'
const FIELD_MVERIFY_P = DATAS.fieldsToFieldsIndex(mverify_fields_p)

export function amountGetGroups(indata) {
    return CLAPI.getData(indata, 'grps', 0)
}
export function amountToDatas(indata, nfield, factorfname) {
    let vars = []
    const grps = CLAPI.getData(indata, 'grps', 0)
    if (factorfname) {
        for (let index = 0; index < indata.datas.length; index++) {
            if (factorfname !== CLAPI.getData(indata, 'fname', index)) {
                continue
            }
            for (let group = 4, ii = 0; group >= 0; group--, ii++) {
                const fname = nfield + group.toString()
                vars.push([ii, CLAPI.getData(indata, fname, index) * 100.0])
            }
            break;
        }
        return {
            fields: FIELD_MVERIFY_P,
            datas: vars
        }
    }
    else {
        for (let index = 0; index < indata.datas.length; index++) {
            const curdate = CLAPI.getData(indata, 'date', index)
            let curv = [curdate]
            for (let group = 0; group < grps; group++) {
                const fname = nfield + group.toString()
                curv.push(CLAPI.getData(indata, fname, index))
            }
            vars.push(curv)
        }
        return {
            fields: FIELD_WVERIFY_R,
            datas: vars
        }
    }
}

export function amountToDatasSingle(indata, nfield, factorfname) {
    let vars = []
    const grps = CLAPI.getData(indata, 'grps', 0)
    if (factorfname) {
        for (let index = 0; index < indata.datas.length; index++) {
            if (factorfname !== CLAPI.getData(indata, 'fname', index)) {
                continue
            }
            for (let group = 4, ii = 0; group >= 0; group--, ii++) {
                const fname = nfield + group.toString()
                vars.push([ii, CLAPI.getData(indata, fname, index) * 100.0])
            }
            break;
        }
        return {
            fields: FIELD_MVERIFY_P,
            datas: vars
        }
    }
    // for (let index = 0; index < indata.datas.length; index++) {
    //     const curdate = CLAPI.getData(indata, 'date', index)
    //     let curv = [curdate]
    //     for (let group = 0; group < grps; group++) {
    //         const fname = nfield + group.toString()
    //         curv.push(CLAPI.getData(indata, fname, index))
    //     }
    //     vars.push(curv)
    // }
    // return {
    //     fields: FIELD_WVERIFY_R,
    //     datas: vars
    // }
}
export const CHART_VERIFY_FACTORS = {
    style: 'vertical', // 'vertical'
    title: {
        label: '因子集',
        height: 23,
    },
    ctrls: []
}
export function setFactorsTitle(name) {
    CHART_VERIFY_FACTORS.title.label = name
}
export function clearFactors() {
    CHART_VERIFY_FACTORS.ctrls = []
}
// 0 灰 代表没什么用
// 1 红 代表值越大收益越高 绿 代表值越大收益越低
// 2 红 代表值越小收益越高 绿 代表值越小收益越低
// 3 红 代表值越大收益越高 代表值越小收益越低 ｜ 绿 代表值越小收益越高 代表值越大收益越低
export function calcFactorInfo(ipos, ineg) {
    let info = 0
    ipos = ipos % 10
    ineg = ineg % 10
    if (ipos === 1) {
        if (ineg === 2) {
            info = 3
        } 
        else if (ineg === 0) {
            info = 1
        }
    }
    else if (ipos === 2) {
        if (ineg === 1) {
            info = -3
        } 
        else if (ineg === 0) {
            info = 2
        }
    }
    else if (ipos === 0) {
        if (ineg === 1) {
            info = -1
        } 
        else if (ineg === 2) {
            info = -2
        }
    }
    return info;
}
export function incrFactors(fname, values) {
    // console.log(fname);
    const info = {
        label: CHART_VERIFY_FACTORS.ctrls.length + '.' + fname,
        clickValue: fname,
        value : [],
    }
    if (values !== undefined && values.length > 0) {
        for (let index = 0; index < values.length; index++) {
            let clr = 'txt'
            if (values[index] > 0) {
                clr = 'red'
            }
            if (values[index] < 0) {
                clr = 'green'
            }
            info.value.push({
                label : Math.abs(values[index]),
                color : clr,
            })
        }
    }
    CHART_VERIFY_FACTORS.ctrls.push(info)
}

export const CHART_VERIFY_HEAD = {
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        showinfo: 'sorted',
        label: '' // 需要显示的文字信息
    },
    buttons: [{ // 放大
            clickName: 'expand',
            drawMethod: 'expand', // 画+号
        },
    ],
    axisX: {
        lines: 0,
        display: 'none',
        left: {
            display: 'none', // chunk normal
        },
        right: {
            display: 'none',
        },
        middle: {
            display: 'none',
        },
    },
    axisY: {
        display: 'normal',
        lines: 3,
        left: {
            display: 'none', // none不显示，all, noupper不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'normal', // 是否有中间值 'before' = 前收盘 ‘zero’ 0为中间值
            format: 'float' // 输出数据的格式 rate, price, vol money
        },
        right: {
            display: 'both', // none不显示，noupper不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'normal', // 是否有中间值 'before'=前收盘 ‘zero’ 0为中间值
            format: 'float' // rate, price vol
        }
    },
    lines: []
}
export const CHART_VERIFY_FOOT = {
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        showinfo: 'sorted',
        label: '' // 需要显示的文字信息
    },
    buttons: [{ // 放大
            clickName: 'expand',
            drawMethod: 'expand', // 画+号
        },
    ],
    axisX: {
        lines: 0,
        display: 'normal',
        left: {
            display: 'normal', // chunk normal
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'none',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        display: 'normal',
        lines: 3,
        left: {
            display: 'none', // none不显示，all, noupper不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'normal', // 是否有中间值 'before' = 前收盘 ‘zero’ 0为中间值
            format: 'float' // 输出数据的格式 rate, price, vol money
        },
        right: {
            display: 'both', // none不显示，noupper不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'normal', // 是否有中间值 'before'=前收盘 ‘zero’ 0为中间值
            format: 'float' // rate, price vol
        }
    },
    lines: []
}

export function onInit(classes, minutes) {
    CHART_VERIFY_MCLASS.ctrls = []
    for (let wvi = 0; wvi < classes.length; wvi++) {
        CHART_VERIFY_MCLASS.ctrls.push({
            label: classes[wvi],
            clickValue: classes[wvi],
        })
    }
    CHART_VERIFY_MINUTE.ctrls = []
    for (let wvi = 0; wvi < minutes.length; wvi++) {
        CHART_VERIFY_MINUTE.ctrls.push({
            label: minutes[wvi],
            clickValue: minutes[wvi],
        })
    }
}

const chartFocus = []
export function clearFocus() {
    chartFocus.length = 0
}
export function changeFocus(chartName, cvname, redraw) {
    console.log(chartName, cvname);
    let findidx = -1
    for (let index = 0; index < chartFocus.length; index++) {
        if (chartFocus[index].chartName === chartName && chartFocus[index].cvname === cvname) {
            findidx = index;
            break;
        }       
    }
    let oldfocus = -1
    for (let index = 0; index < chartFocus.length; index++) {
        if (chartFocus[index].focus) {
            oldfocus = index;
        }       
    }
    const curChart = Init.getSysChart()
    let newfocus = -1
    if (findidx < 0) {
        // 以前没有
        const chart = curChart.getUserChart(chartName, cvname)
        if (chart !== undefined) {
            newfocus = chartFocus.length
            chartFocus.push({
                chartName, 
                cvname, 
                focus : true, 
            })
        }
    }
    else {
        if (redraw || !chartFocus[findidx].focus) {
            newfocus = findidx
        }
    }
    console.log(findidx, oldfocus, newfocus);
    if (newfocus >= 0) {
        if (oldfocus >= 0) {
            const chart = curChart.getUserChart(chartFocus[oldfocus].chartName, chartFocus[oldfocus].cvname)
            // console.log(chart.name, false);
            chart.setFocused(false)
            chartFocus[oldfocus].focus = false
        }
        const chart = curChart.getUserChart(chartFocus[newfocus].chartName, chartFocus[newfocus].cvname)
        // console.log(chart, chartFocus);
        // console.log(oldfocus, newfocus, chart.name, true);
        chart.setFocused(true)
        chartFocus[newfocus].focus = true
    
    }
    return newfocus !== oldfocus
}

export function setFocus() {
    let curfocus = -1
    for (let index = 0; index < chartFocus.length; index++) {
        if (chartFocus[index].focus) {
            curfocus = index;
        }       
    }
    console.log(curfocus);
        
    if (curfocus >= 0) {
        const curChart = Init.getSysChart()
        const chart = curChart.getUserChart(chartFocus[curfocus].chartName, chartFocus[curfocus].cvname)
        chart.setFocused(true)
    }
}


////////////////////
